module.exports = __webpack_public_path__ + "media/images/athletes/2201-87306d08c49c15e5c5854d9962f60f0d.png";